module.exports = __webpack_public_path__ + "img/OrganizationalCultureIcon.ee9e3bf5.svg";